export const safeObj = (obj) => {
    return obj !== null && typeof obj === 'object' && Object.keys(obj).length
}